import React from 'react';
import style from './add-card-choice.module.scss';
import { Switch } from '../../../../components';
import { CardChoice} from './AddCardChoice'
import { SetState } from '../../../../types'

type Props = {
	state: CardChoice 
	setState: SetState<CardChoice>
	mode: "view" | "edit" | "create"
}

export function Toggles(props: Props) {
	const { state, setState, mode } = props

	const styles = {
		isMulti: {
			'--checked-bg': state.isMulti ? '#F1722E' : '',
		},
		isCreateable: {
			'--checked-bg': state.isCreatable ? '#F1722E' : '',
		},
		isClearable: {
			'--checked-bg': state.isClearable ? '#F1722E' : '',
		},
	}

	return (
		<div className={style.switches}>
			<div className={style.switchWrapper} style={styles.isMulti as any}>
				<p>Multiple</p>
				<Switch
					disabled={mode === "view"}
					checked={state.isMulti ?? false}
					onSwitch={(isMulti) => {
						setState((prev) => ({ ...prev, isMulti }));
					}}
				/>
			</div>
			<div className={style.line} />
			<div className={style.switchWrapper} style={styles.isClearable as any}>
				<p>Clearable</p>
				<Switch
					checked={state.isClearable ?? false}
					disabled={mode === "view"}
					onSwitch={(isClearable) => {
						setState((prev) => ({ ...prev, isClearable }));
					}}
				/>
			</div>
			<div className={style.line} />
			<div className={style.switchWrapper} style={styles.isCreateable as any}>
				<p>Creatable</p>
				<Switch
					checked={state.isCreatable ?? false}
					disabled={mode === "view"}
					onSwitch={(isCreatable) => {
						setState((prev) => ({ ...prev, isCreatable }));
					}}
				/>
			</div>
		</div>
	);
}
